(function () {
  if (!customElements.get("pi-giveaway-form")) {
    customElements.define(
      "pi-giveaway-form",
      class PiGiveawayForm extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === "true") return;
          this.dataset.bound = "true";

          this.form = this.querySelector("form");
          this.initPhone();
          if (this.form) {
            this.form.addEventListener("submit", this.onSubmit.bind(this));
            this.form.addEventListener("input", this.syncSubmitState.bind(this));
            this.form.addEventListener("change", this.syncSubmitState.bind(this));
          }
          this.addEventListener("click", this.onCopyClick.bind(this));
          this.syncSubmitState();
          this.restoreTicket();
        }

        storageKey() {
          var customerId = this.dataset.customerId || "";
          var productId = this.fieldValue("product_id");
          if (!customerId || !productId) return "";
          return "pi-giveaway-ticket:" + customerId + ":" + productId;
        }

        readTicket() {
          var key = this.storageKey();
          if (!key) return null;
          try {
            var data = JSON.parse(window.localStorage.getItem(key) || "null");
            if (!data || !data.ticket_number) return null;
            if (String(data.customer_id) !== String(this.dataset.customerId || "")) return null;
            if (String(data.product_id) !== this.fieldValue("product_id")) return null;
            return data;
          } catch (error) {
            return null;
          }
        }

        saveTicket(number, created) {
          var key = this.storageKey();
          if (!key || !number || this.isDesignMode()) return;
          try {
            window.localStorage.setItem(
              key,
              JSON.stringify({
                ticket_number: number,
                created: created === true,
                customer_id: this.dataset.customerId,
                product_id: this.fieldValue("product_id"),
              }),
            );
          } catch (error) {}
        }

        restoreTicket() {
          if (this.isDesignMode()) return;
          var saved = this.readTicket();
          if (!saved) return;
          this.showSuccess(saved.ticket_number, saved.created === true, false);
        }

        initPhone() {
          var input = this.querySelector('[name="phone"]');
          if (!input || this.iti) return;
          if (!window.intlTelInput) {
            if (this.dataset.phoneWait === "true") return;
            this.dataset.phoneWait = "true";
            var self = this;
            var retry = function () {
              if (window.intlTelInput) self.initPhone();
            };
            if (document.readyState === "complete") window.setTimeout(retry, 0);
            else window.addEventListener("load", retry, { once: true });
            return;
          }
          var utilsUrl =
            "https://cdn.jsdelivr.net/npm/intl-tel-input@29.5.5/dist/js/utils.js";
          this.utilsReady = import(utilsUrl);
          this.iti = window.intlTelInput(input, {
            initialCountry: "pr",
            countryOrder: ["pr", "us"],
            countryNameLocale: "es",
            separateDialCode: true,
            formatAsYouType: true,
            nationalMode: true,
            strictMode: true,
            dropdownParent: document.body,
            uiTranslations: {
              selectedCountryAriaLabel:
                "Cambiar el país del teléfono, actualmente ${countryName} (${dialCode})",
              noCountrySelected: "Selecciona el país del teléfono",
              countryListAriaLabel: "Lista de países",
              searchPlaceholder: "Buscar",
              clearSearchAriaLabel: "Borrar búsqueda",
              closeCountrySelectorAriaLabel: "Cerrar",
              searchEmptyState: "No se encontraron resultados",
              searchSummaryAria: function (count) {
                if (count === 0) return "No se encontraron resultados";
                if (count === 1) return "1 resultado";
                return count + " resultados";
              },
            },
            loadUtils: function () {
              return import(utilsUrl);
            },
          });
          this.syncSubmitState();
        }

        formReady() {
          if (this.dataset.submitting === "true") return false;
          if (!this.fieldValue("name") || !this.fieldValue("email") || !this.fieldValue("phone"))
            return false;
          var email = this.querySelector('[name="email"]');
          if (email && email.validity && email.validity.typeMismatch) return false;
          return true;
        }

        syncSubmitState() {
          var button = this.form && this.form.querySelector('[type="submit"]');
          if (!button) return;
          button.disabled = !this.formReady();
        }

        phoneErrorMessage() {
          var input = this.querySelector('[name="phone"]');
          var value = input ? input.value.trim() : "";
          if (!value) return "Ingresa un número de teléfono.";
          var errors =
            window.intlTelInput && window.intlTelInput.VALIDATION_ERROR;
          var code = this.iti ? this.iti.getValidationError() : null;
          if (errors && code === errors.TOO_SHORT)
            return "El número es demasiado corto.";
          if (errors && code === errors.TOO_LONG)
            return "El número es demasiado largo.";
          if (errors && code === errors.INVALID_COUNTRY_CODE)
            return "El código de país no es válido.";
          return "El teléfono debe ser un número válido.";
        }

        phoneNumber() {
          if (!this.iti || typeof this.iti.isValidNumber !== "function") {
            return this.toE164(this.fieldValue("phone"));
          }
          if (this.iti.isValidNumber()) return this.iti.getNumber();
          if (this.iti.isValidNumber() === null) {
            return this.toE164(this.fieldValue("phone"));
          }
          return "";
        }

        isDesignMode() {
          return document.documentElement.classList.contains(
            "shopify-design-mode",
          );
        }

        toE164(value) {
          var raw = String(value || "").trim();
          if (!raw) return "";
          if (raw.charAt(0) === "+") {
            var compact = "+" + raw.slice(1).replace(/\D/g, "");
            return /^\+[1-9]\d{1,14}$/.test(compact) ? compact : "";
          }
          var digits = raw.replace(/\D/g, "");
          if (digits.length === 10) return "+1" + digits;
          return "";
        }

        postTicket(payload) {
          return fetch("https://trucklife.musiconpr.com/api/giveaway", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(payload),
          });
        }

        fieldValue(name) {
          var input = this.querySelector('[name="' + name + '"]');
          return input ? input.value.trim() : "";
        }

        setBusy(busy) {
          this.dataset.submitting = busy ? "true" : "false";
          this.syncSubmitState();
        }

        clearErrors() {
          var banner = this.querySelector("[data-form-error]");
          if (banner) {
            banner.hidden = true;
            banner.textContent = "";
          }
          this.querySelectorAll("[data-error-for]").forEach(function (node) {
            node.hidden = true;
            node.textContent = "";
          });
          this.querySelectorAll(
            "[name='name'], [name='email'], [name='phone']",
          ).forEach(function (input) {
            input.removeAttribute("aria-invalid");
          });
        }

        showBanner(message) {
          var banner = this.querySelector("[data-form-error]");
          if (!banner) return;
          banner.hidden = false;
          banner.textContent = message;
        }

        showFieldError(key, message) {
          var slot = this.querySelector('[data-error-for="' + key + '"]');
          var input = this.querySelector('[name="' + key + '"]');
          if (slot) {
            slot.hidden = false;
            slot.textContent = message;
          }
          if (input) {
            input.setAttribute("aria-invalid", "true");
            if (slot && slot.id)
              input.setAttribute("aria-describedby", slot.id);
          }
          return Boolean(slot);
        }

        applyErrors(data) {
          var errors = data && data.errors;
          var attached = false;
          if (errors && typeof errors === "object") {
            Object.keys(errors).forEach(function (key) {
              var messages = errors[key];
              var text = Array.isArray(messages)
                ? messages.filter(Boolean).join(" ")
                : String(messages || "");
              if (text && this.showFieldError(key, text)) attached = true;
            }, this);
          }
          if (data && data.message) this.showBanner(data.message);
          else if (!attached)
            this.showBanner("Revisa los datos e inténtalo de nuevo.");
        }

        showSuccess(number, created, scroll) {
          var panel = this.querySelector("[data-form-panel]");
          var success = this.querySelector("[data-success]");
          if (panel) panel.hidden = true;
          if (success) success.hidden = false;
          document.documentElement.classList.add("pi-giveaway-entered");
          if (number) {
            this.querySelectorAll("[data-entry-number]").forEach(
              function (node) {
                node.textContent = number;
              },
            );
            this.saveTicket(number, created);
          }

          var title = this.querySelector("[data-success-title]");
          var text = this.querySelector("[data-success-text]");
          var emailNote = this.querySelector("[data-email-note]");
          if (created === false) {
            if (title && this.dataset.alreadyHeading)
              title.textContent = this.dataset.alreadyHeading;
            if (text && this.dataset.alreadyMessage)
              text.textContent = this.dataset.alreadyMessage;
            if (emailNote) emailNote.hidden = true;
          } else if (created === true) {
            if (title && this.dataset.successHeading)
              title.textContent = this.dataset.successHeading;
            if (text && this.dataset.successMessage)
              text.textContent = this.dataset.successMessage;
            if (emailNote) emailNote.hidden = false;
          }

          if (
            scroll &&
            success &&
            typeof success.scrollIntoView === "function"
          ) {
            success.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }

        onCopyClick(event) {
          var button = event.target.closest("[data-copy-ticket]");
          if (!button || !this.contains(button)) return;
          event.preventDefault();
          this.copyTicket(button);
        }

        copyTicket(button) {
          var node = this.querySelector("[data-entry-number]");
          var number = node ? node.textContent.trim() : "";
          if (!number) return;
          var self = this;
          var finish = function () {
            self.showCopied(button);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(number).then(finish).catch(function () {
              if (self.copyWithSelection(number)) finish();
            });
            return;
          }
          if (this.copyWithSelection(number)) finish();
        }

        copyWithSelection(number) {
          var area = document.createElement("textarea");
          area.value = number;
          area.setAttribute("readonly", "");
          area.style.position = "fixed";
          area.style.top = "0";
          area.style.left = "-9999px";
          document.body.appendChild(area);
          area.select();
          var copied = false;
          try {
            copied = document.execCommand("copy");
          } catch (error) {
            copied = false;
          }
          document.body.removeChild(area);
          return copied;
        }

        showCopied(button) {
          var status = this.querySelector("[data-copy-status]");
          if (status) status.hidden = false;
          if (button) button.classList.add("is-copied");
          window.clearTimeout(this.copyTimer);
          var self = this;
          this.copyTimer = window.setTimeout(function () {
            if (status) status.hidden = true;
            if (button) button.classList.remove("is-copied");
          }, 2000);
        }

        handleResponse(response, data) {
          this.setBusy(false);
          var status = response.status;
          if (
            (status === 200 || status === 201) &&
            data &&
            data.ticket_number
          ) {
            var created = data.created === true;
            if (data.created !== false && status === 201) created = true;
            this.showSuccess(data.ticket_number, created, true);
            return;
          }

          if (status === 422) {
            this.applyErrors(data || {});
            return;
          }

          if (status === 409) {
            this.showBanner("Inténtalo de nuevo.");
            return;
          }

          this.showBanner(
            (data && data.message) ||
              "No se pudo completar el registro. Inténtalo de nuevo.",
          );
        }

        onSubmit(event) {
          event.preventDefault();
          if (this.isDesignMode()) return;
          if (this.dataset.submitting === "true") return;
          var saved = this.readTicket();
          if (saved) {
            this.showSuccess(saved.ticket_number, saved.created === true, true);
            return;
          }

          if (this.form && !this.form.reportValidity()) return;

          var self = this;
          var ready = this.utilsReady || Promise.resolve();
          ready
            .catch(function () {
              return null;
            })
            .then(function () {
              self.submitRegistration();
            });
        }

        submitRegistration() {
          if (this.dataset.submitting === "true") return;

          var phone = this.phoneNumber();
          this.clearErrors();
          if (!phone) {
            this.showFieldError("phone", this.phoneErrorMessage());
            var phoneInput = this.querySelector('[name="phone"]');
            if (phoneInput) phoneInput.focus();
            return;
          }

          var productId = Number(this.fieldValue("product_id"));
          if (!productId) {
            this.showBanner("El registro no está disponible en este momento.");
            return;
          }

          var rules = this.querySelector("[data-rules]");
          var payload = {
            name: this.fieldValue("name"),
            email: this.fieldValue("email"),
            phone: phone,
            product_id: productId,
            marketing: Boolean(rules && rules.checked),
          };

          this.setBusy(true);
          var self = this;
          this.postTicket(payload)
            .then(function (response) {
              if (response.status === 409) return self.postTicket(payload);
              return response;
            })
            .then(function (response) {
              return response
                .json()
                .catch(function () {
                  return {};
                })
                .then(function (data) {
                  return { response: response, data: data };
                });
            })
            .then(function (result) {
              self.handleResponse(result.response, result.data);
            })
            .catch(function () {
              self.setBusy(false);
              self.showBanner(
                "No se pudo completar el registro. Inténtalo de nuevo.",
              );
            });
        }
      },
    );
  }

  if (!customElements.get("pi-giveaway-lightbox")) {
    customElements.define(
      "pi-giveaway-lightbox",
      class PiGiveawayLightbox extends HTMLElement {
        connectedCallback() {
          if (this.dataset.bound === "true") return;
          this.dataset.bound = "true";
          this.addEventListener("click", this.onClick.bind(this));
        }

        onClick(event) {
          var trigger = event.target.closest("[data-full]");
          if (!trigger || !this.contains(trigger)) return;
          event.preventDefault();
          this.open(
            trigger.getAttribute("data-full"),
            trigger.getAttribute("data-alt") || "",
          );
        }

        open(src, alt) {
          var dialog = this.querySelector("dialog");
          if (!dialog) {
            dialog = document.createElement("dialog");
            dialog.className = "pi-lightbox__dialog";
            dialog.innerHTML =
              '<button type="button" class="pi-lightbox__close" aria-label="Cerrar">×</button><img class="pi-lightbox__img" alt="">';
            this.appendChild(dialog);
            dialog
              .querySelector("button")
              .addEventListener("click", function () {
                dialog.close();
              });
            dialog.addEventListener("click", function (clickEvent) {
              if (clickEvent.target === dialog) dialog.close();
            });
          }

          var image = dialog.querySelector("img");
          image.src = src;
          image.alt = alt;
          if (typeof dialog.showModal === "function") dialog.showModal();
        }
      },
    );
  }
})();
